<template>
  <div class="header">
    <!-- Image and text -->
    <!-- <b-navbar variant="faded" type="light">
      <div class="mr-lg-5 ml-lg-4">
        <Burger />
      </div>
      <b-navbar-brand href="/" class="mx-lg-auto ml-lg-5">
        <img src="@/assets/logo.png" class="d-inline-block align-top" style="height: 50px" />
      </b-navbar-brand>
      <changelocale class="ml-auto" />
      <Contactus class="mr-lg-1" />
 <b-navbar variant="faded" type="light" class="flex-container">
    <!-- Burger menu on the left -->
    <b-navbar variant="faded" type="light" class="flex-container">
      <div class="burger-menu">
        <Burger />
      </div>

      <!-- Logo in the center -->
      <b-navbar-brand href="/" class="mx-auto navbar-logo">
        <img src="@/assets/logo.png" class="d-inline-block align-top" style="height: 50px;" />
      </b-navbar-brand>

      <!-- Locale change and contact on the right -->
      <div class="header-controls ml-auto">
        <changelocale />
        <Contactus />
      </div>
    </b-navbar>

  </div>
</template>

<script>
import Burger from "@/components/Burger.vue";
import Contactus from "@/components/buttons/ContactUs.vue";
import changelocale from "@/components/buttons/ChangeLocale.vue";

export default {
  name: "theader",
  components: {
    Burger,
    Contactus,
    changelocale,
  },
  data() {
    return {
      msg: "",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  height: 75px;
  width: 100%;

}

.header {
  width: 100%;
}

.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.burger-menu {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  /* Aligns the burger menu to the left */
}

.navbar-logo {
  flex: 1;
  display: flex;
  justify-content: center;
  /* Centers the logo */
}

.header-controls {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  /* Aligns locale change and contact to the right */
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue